module.exports = __webpack_public_path__ + "static/media/adobe-premiere.03deeca8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/adobe-premiere.svg
// module id = 2074
// module chunks = 0